import ModalShell from "../../../../_components/modal/ModalShell";
import ConfirmDialog from "../../../../_components/modal/ConfirmDialog";
import DynamicForm from "../../../../_components/form/DynamicForm";
import { useUserManagementFormState } from "./hooks/useUserManagementFormState";
import "./_user-management-form-modal.scss";

/**
 * UI Layer - presentational composition only, mirrors every other migrated
 * modal's shape: ModalShell + DynamicForm + ConfirmDialog. `rowData` is
 * expected to already be row-mapped (see utils/userManagementRowMapping.js,
 * called from the page's edit handler) before it reaches this component.
 */
const UserManagementFormModal = ({ isOpen, onClose, rowData, mode, onSuccess, refetchFilters }) => {
  const {
    control,
    schema,
    formData,
    errors,
    handleChange,
    handleBlur,
    showCloseConfirmation,
    isSubmitting,
    attemptClose,
    confirmDiscard,
    cancelDiscard,
    onSubmit,
  } = useUserManagementFormState({ mode, rowData, isOpen, onClose, onSuccess, refetchFilters });

  return (
    <>
      <ModalShell
        isOpen={isOpen}
        onRequestClose={attemptClose}
        width="500px"
        height="100vh"
        center={false}
        right={0}
        className="user-management-form-modal--right-docked"
        title={mode === "edit" ? "Edit user" : "Create user"}
        isSubmitting={isSubmitting}
        footerButtons={[
          { children: "Close", onClick: attemptClose, variant: "outlined" },
          {
            children: mode === "edit" ? "Update" : "Create",
            onClick: onSubmit,
            variant: "contained",
            loading: isSubmitting,
          },
        ]}
      >
        <form onSubmit={onSubmit}>
          <DynamicForm
            schema={schema}
            control={control}
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
            mode={mode}
            disabled={isSubmitting}
          />
        </form>
      </ModalShell>

      <ConfirmDialog
        isOpen={showCloseConfirmation}
        title="Discard unsaved changes?"
        description="You have unsaved changes. Are you sure you want to close without saving?"
        cancelText="Keep editing"
        confirmText="Discard changes"
        onCancel={cancelDiscard}
        onConfirm={confirmDiscard}
      />
    </>
  );
};

export default UserManagementFormModal;
